import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const countryApi = createApi({
  reducerPath: 'countryApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getForSelect: builder.query({
      query: () => ({ url: 'customer/countries/for-select' }),
    }),
    getForInputForSelect: builder.query({
      query: () => ({ url: 'customer/countries/input/for-select' }),
    }),
    getForDidsForSelect: builder.query({
      query: () => ({ url: 'customer/countries/dids/for-select' }),
    }),
    getWithAvailablePlansForSelect: builder.query({
      query: () => ({ url: 'customer/countries/plans/for-select' }),
    }),
    getTos: builder.query({
      query: (arg) => {
        const { country } = arg;
        return { url: `customer/countries/${country}/tos` };
      },
      providesTags: (result, error, { country }) => [
        { type: 'CountryTos', country },
      ],
      transformResponse: (response) => {
        const services = {
          3: {
            description: 'LT',
            available: false,
          },
          2: {
            description: 'PSTN',
            available: false,
          },
          10: {
            description: 'SMS',
            available: false,
          },
        };
        response
          .filter(({ value: id }) => Object.keys(services).includes(String(id)))
          .forEach(({ value: id }) => {
            services[id].available = true;
          });
        return services;
      },
    }),
    getDidTypes: builder.query({
      query: (arg) => {
        const { id } = arg;
        return { url: `customer/plans/countries/${id}/did-types` };
      },
      providesTags: (result, error, { country }) => [
        { type: 'CountryDidTypes', country },
      ],
      transformResponse: (response) => {
        const didTypes = {
          1: {
            description: 'Geographic',
            available: false,
          },
          2: {
            description: 'Mobile',
            available: false,
          },
          4: {
            description: 'National',
            available: false,
          },
          5: {
            description: 'Tollfree',
            available: false,
          },
          6: {
            description: 'Shared Cost',
            available: false,
          },
          7: {
            description: 'UIFN',
            available: false,
          },
        };
        response
          .filter(({ id }) => Object.keys(didTypes).includes(String(id)))
          .forEach(({ id }) => {
            didTypes[id].available = true;
          });
        return didTypes;
      },
    }),
    getDestinationsForSelect: builder.query({
      query: ({ id }) => ({
        url: `customer/plans/countries/${id}/destinations/for-select`,
      }),
    }),
    getForSelectForDidGroups: builder.query({
      query: () => ({
        url: `customer/capacity/did-groups/countries/for-select`,
      }),
    }),
  }),
});
